// eslint-disable-next-line import/prefer-default-export
export const apiUrl = `${process.env.VUE_APP_API}`;
